import { useMutation } from '@tanstack/react-query';

import { getCadesError, signBytes, withCachedKey } from '@app/services/cades';
import { ICertificate } from '@app/services/cades/interfaces';

interface IProbeParams {
  certificate: ICertificate;
  content: string;
  count: number;
}

export interface IProbeResult {
  signature?: string;
  error?: string;
}

export const useProbeSignature = () =>
  useMutation({
    mutationFn: async ({ certificate, content, count }: IProbeParams) => {
      const run = async () => {
        const results: IProbeResult[] = [];
        for (let index = 0; index < count; index++) {
          try {
            results.push({ signature: await signBytes(certificate, content) });
          } catch (error) {
            results.push({ error: getCadesError(error) });
          }
        }
        return results;
      };
      return count > 1 ? withCachedKey(certificate, run) : run();
    },
    retry: false,
  });
